import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController, ToastController } from 'ionic-angular';

import { Http } from '@angular/http';

@IonicPage()
@Component({
  selector: 'page-perfil',
  templateUrl: 'perfil.html',
})
export class PerfilPage {
  nombre;
  apellidos;
  celular;
  telefono;
  nif;
  referencia;
  dirrecion;
  ciudad;
  correo;
  user;
  language = {};
  constructor(public navCtrl: NavController, public navParams: NavParams,
    public alertCtrl: AlertController,public http: Http,public toastCtrl: ToastController) {
      this.http.get('https://ebenlovequickpc.com/i18n/languaje.php?lang='+localStorage.getItem('language')).subscribe((data)=>{
      this.language = data.json();
    })
    this.user=JSON.parse(localStorage.getItem("user"));
    this.nombre=this.user.NOMBRE;
    this.apellidos=this.user.APELLIDOS;
    this.celular=this.user.CELULAR;
    this.telefono=this.user.TELEFONO;
    this.nif=this.user.NIF;
    this.referencia=this.user.REFERENCIA;
    this.dirrecion=this.user.DIRECCION;
    this.ciudad=this.user.CIUDAD;
    this.correo=this.user.CORREO;
  }
  showPrompt() {
    let prompt = this.alertCtrl.create({
      title: 'Cambiar password',
      inputs: [
        {
          name: 'pw',
          type: 'password',
          placeholder: 'password'
        },
      ],
      buttons: [
        {
          text: 'Cancel',
          handler: data => {
          }
        },
        {
          text: 'Enviar',
          handler: data => {
            let params = "codigo_user="+this.user.CODIGO_USER+"&pw="+data.pw;
            setTimeout(()=>{
              this.http.get('https://ebenlovequickpc.com/API/session.php?cl=update&'+params).subscribe((datos)=>{
               });
               let toast = this.toastCtrl.create({
                message: 'Password Cambiado',
                duration: 3000
              });
              toast.present();
            },3000);
          }
        }
      ]
    });
    prompt.present();
  }
  editarPerfil(){
    let params = "codigoUser="+this.user.CODIGO_USER+"&nombre="+this.nombre+"&apellidos="+this.apellidos+"&celular="+this.celular+"&telefono="+this.telefono+"&nif="+this.nif+"&referencia="+this.referencia+"&dirrecion="+this.dirrecion+"&ciudad="+this.ciudad+"&email="+this.correo;
    this.http.get('https://ebenlovequickpc.com/API/perfil.php?cl=update&'+params).subscribe((datos)=>{
      //setTimeout(()=>{
        localStorage.setItem("user",JSON.stringify(datos.json()));
      //},3000);

   });
  }
  ionViewDidLoad() {
  }

}



// WEBPACK FOOTER //
// ./src/pages/perfil/perfil.ts